import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=0e8b5bfc&scoped=true"
import script from "./LeadDetails.vue?vue&type=script&lang=js"
export * from "./LeadDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8b5bfc",
  null
  
)

export default component.exports